function inPagination() {
    const main = jQuery('.tour-post');
    const nav = main.find('.block-in-page-naviagation');
    const navigationMenu = nav.find('.nav-list > ul');

    generateLinks();
    navigationMenu.on(
        'click',
        '.inpage-nav__link',
        navLinkClick.bind(this)
    );
    stickNav();

    if (navigationMenu.children().length === 0) {
        nav.hide();
    }

    jQuery(window).on('scroll', scrollSpy);
}

function generateLinks() {
    const main = jQuery('.tour-post');
    const nav = main.find('.block-in-page-naviagation');
    const navigationMenu = nav.find('.nav-list > ul');
    const sections = main.find('section, .block-hook');

    sections.each((index, el) => {
        const id = jQuery(el).attr('id');

        if (
            id &&
            id.toLowerCase().indexOf('block-program-hero') === -1 &&
            id.toLowerCase().indexOf('hero') === -1
        ) {
            const link = id.replaceAll(' ', '-');
            let title = id.replace('block-trex-', ' ');
            title = title.replaceAll('-', ' ');
            if( link === 'dates-costs' ){
                title = 'dates & costs';
            }
            const element = `<li class="inpage-nav__list-item"><a class="inpage-nav__link" role="button" href="#${link}">${title}</a></li>`;
            navigationMenu.append(element);
        }
    });
    if (jQuery('body').hasClass('single-tours')) {
        const tripUpdatesItem = `
          <li class="inpage-nav__list-item trip-updates-nav">
            <a class="inpage-nav__link open-new-page" href="/trip-updates" target="_blank">
              Trip Updates
            </a>
          </li>`;
        navigationMenu.append(tripUpdatesItem);
      }
}

function navLinkClick(e) {        
    const main = jQuery('.tour-post');
    const nav = main.find('.block-in-page-naviagation');
    const navigationMenu = nav.find('.nav-list > ul');

    const element = jQuery(e.target);
    navigationMenu.find('.inpage-nav__link').removeClass('active');
    element.addClass('active');
}

function stickNav() {
        
    const body = jQuery('body');
    const main = jQuery('.tour-post');
    const nav = main.find('.block-in-page-naviagation');
    const header = body.find('.main-header');
    const wpadminbar = body.find('#wpadminbar');

    let top = 0;
    if (wpadminbar.length !== 0) {
        top = top + wpadminbar.outerHeight();
    }
    if (header.length !== 0) {
        top = top + header.outerHeight();
    }
    nav.css({ top });
}

function scrollSpy() {

    const sections = jQuery('section'),
        nav = jQuery('.trex-inpage-nav'),
        navHeight = nav.outerHeight(),
        mobileBtn = nav.find(
            '.inpage-nav__mobile-toggle span:first-child'
        );
    const header = jQuery('.main-header');
    let headerHeight = 0;
    const alertBar = jQuery('.alert-bar');
    let alertBarHeight = 0;
    if (alertBar.length !== 0) {
        alertBarHeight = alertBar.outerHeight();
    }
    if (header.length !== 0) {
        headerHeight = header.outerHeight();
    }
    let timer;
    jQuery(window).on('scroll', function () {
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            const curPos = jQuery(this).scrollTop();
            sections.each(function () {
                const top =
                        jQuery(this).offset().top -
                        navHeight -
                        alertBarHeight -
                        headerHeight -
                        100,
                    bottom = top + jQuery(this).outerHeight();
                if (curPos >= top && curPos <= bottom) {
                    nav.find('.inpage-nav__link').removeClass('active');
                    const curLink = nav.find(
                        '.inpage-nav__link[href="#' +
                            jQuery(this).attr('id') +
                            '"]'
                    );
                    const text = curLink.text();
                    if (text) {
                        mobileBtn.text(text);
                    }
                    curLink.addClass('active');
                }
            });
        }, 25);
    });
}
  
  // GLOBAL APP CONTROLLER
  const controller = {
    init() {
        inPagination();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown() {},
    mouseUp() {},
  };
  export default controller;
  